<template>
  <button class="btn">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'my-button'
}
</script>

<style scoped>
.btn {
  display: block;
  font-size: 45px;
  /* color: #ff7d33; */
  color: var(--bar-color-main);
  background-color: transparent;
  border: 5px solid transparent;
  border-radius: 15px;
  margin-top: 5px;
  /* height: min-content; */
  /* max-height: min-content; */
  /* min-height: auto; */
  /* border: 5px solid #feaa60c9; */
  /* display: flex; */
  padding: 10px;
  border: 5px solid var(--bar-color-light);
}
.btn:hover {
  /* background-color: #fae5d3; */
  background-color: var(--bar-color-back);
}
.btn:active {
  /* border: 5px solid #ff7d33; */
  border: 5px solid var(--bar-color-main);
}
</style>
